import { styled, ToggleButton, Typography } from '@mui/material';

export const ToggleSButtons = styled(ToggleButton)(() => ({
  border: 'none',
  padding: '5px',
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: 'none',
    },
  },
}));

export const InputLabel = styled(Typography)(
  () => `
  font-weight: 400;
  margin-bottom: 16px;
`,
);
